// @flow
const defaultState: AppState = {
  isTestStart: false,
  isTestEnd: false,
  timer: 0,
  score: 0,
  lastScoreModification: 0,
}

export default {
  namespace: 'app',
  state: Object.assign({}, defaultState),
  reducers: {
    tick(state: AppState): AppState {
      if (state.isTestEnd || !state.isTestStart) return state

      return Object.assign({}, state, {
        timer: state.timer + 1
      })
    },
    start(state: AppState): AppState {
      window.ga('send', 'event', 'Переходы', 'К началу игры', 'picture')

      return Object.assign({}, state, {
        isTestStart: true,
      })
    },
    end(state: AppState): AppState {
      return Object.assign({}, state, {
        isTestEnd: true,
      })
    },
    reset(): AppState {
      return Object.assign({}, defaultState)
    },
    modifyScore(state: AppState, { payload } ): AppState {
      return Object.assign({}, state, {
        score: state.score + payload,
        lastScoreModification: payload,
      })
    },
  },
  // effects: {
  //   *start(action, { call, put }) {
  //     yield put({ type: 'tick' });
  //   },
  //
  //   *tick(action, { call, put }) {
  //     yield call(delay, 1000);
  //     yield put({ type: 'tick' });
  //   },
  // },
}

// function delay(timeout){
//   return new Promise(resolve => {
//     setTimeout(resolve, timeout)
//   })
// }



// WEBPACK FOOTER //
// ./src/models/app/index.js